import {OrderRestrictionGenqlSelection} from "@/gql/gen";

export const OrderRestrictionFields: OrderRestrictionGenqlSelection = {
    ID: true,
    NAME: true,
    SCHEDULE: true,
    SCHEDULE_DESC: true,
    SCHEDULE_ACTIVE: true,
    MESSAGE: true,
    ITEM_ERROR_NAME: true,
    ITEM_MESSAGE: true,
    CONDITION: {
        __fragment: 'OrderCondition'
    },
}
